import { exportBatchClaims } from 'features/autocheck/autoCheckApi'
import { IdownloadCSV, ValidationDownloadEnum, ValidationDownloadType } from 'features/autocheck/types'
import { downloadFile } from 'features/autocheck/utils'
import { FaCaretDown, FaDownload } from 'react-icons/fa'
import { OBDropdown } from '@outbound-ai/ursa'

export const BatchDownloadFiles = (batchId: string) => {
  const downloadClaimFile = (batchId: string, type: ValidationDownloadType) => {
    exportBatchClaims(batchId, type).then((res) => {
      if (res) {
        const downloadData: IdownloadCSV = {
          data: res.data,
          fileName: 'Validation_results_BatchId_' + batchId + '.csv',
          fileType: 'text/csv',
        }
        downloadFile(downloadData)
      }
    })
  }

  return (
    <OBDropdown
      variant="primary-outline"
      radius="rounded"
      disableMenuPortal={true}
      buttonName={
        <>
          <FaDownload /> Download Validation Report
          {/* <FaCaretDown className="ms-1" /> */}
        </>
      }
      items={[
        {
          title: 'Validation Reports',
          items: [
            {
              text: 'All Claims CSV',
              onClick: () => downloadClaimFile(batchId, ValidationDownloadEnum.full),
              icon: <FaDownload />,
            },
            {
              text: 'Excluded Claims (.csv)',
              onClick: () => downloadClaimFile(batchId, ValidationDownloadEnum.errorOnly),
              icon: <FaDownload />,
            },
            {
              text: 'Validated Claims (.csv)',
              onClick: () => downloadClaimFile(batchId, ValidationDownloadEnum.successOnly),
              icon: <FaDownload />,
            },
          ],
        },
      ]}
    />
  )
}
